<ng-container
  *ngrxLet="{
    theme: theme$,
  } as vm">
  <mat-toolbar class="flex justify-between" role="navigation">
    <div class="flex align-center gap-8">
      <app-icon-button icon="close" color="on-primary" ariaLabel="Close" [matDialogClose]="true"></app-icon-button>
      <!-- <img id="imgLogo" src="images/logo-white-small.svg" class="mr-5" alt="Logo image" /> -->
    </div>
  </mat-toolbar>
  <div class="mat-list-div">
    @if (subMenuMainItem === null) {
      <div class="search-ipt">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <div class="flex justify-between align-center">
            <input
              matInput
              id="iptSearch"
              type="text"
              [(ngModel)]="searchValue"
              placeholder="What are you looking for?" />
            <div>
              @if (searchValue === '') {
                <app-icon name="search" color="on-surface-variant"></app-icon>
              }
              @if (searchValue !== '') {
                <app-icon-button
                  icon="close"
                  size="sm"
                  ariaLabel="Clear Search"
                  color="on-surface"
                  (clicked)="searchValue = ''"></app-icon-button>
              }
            </div>
          </div>
        </mat-form-field>
      </div>
    }
    @if (subMenuMainItem !== null) {
      <div class="flex flex-col">
        <div class="back-btn-container">
          <div
            class="back-cta"
            role="button"
            tabindex="0"
            aria-label="Back"
            (click)="onBack()"
            (keydown.enter)="onBack()"
            (keydown.space)="$event.preventDefault()"
            (keyup.space)="onBack()">
            <app-icon name="chevron_backward" color="on-surface"></app-icon>
            <span class="label">Back</span>
          </div>
        </div>
        <div class="sub-menu-header-container">
          @if (subMenuMainItem.icon) {
            <app-icon [name]="subMenuMainItem.icon" size="md" color="on-surface"></app-icon>
          }
          <p>{{ subMenuMainItem.name }}</p>
        </div>
      </div>
    }
    <mat-list id="navList" class="nav-list" role="list" data-test="nav-list" data-testid="nav-list">
      @for (navListItem of navList | filter: searchValue; track navListItem) {
        <div>
          <mat-list-item class="nav-menu-item" role="listitem">
            <button
              type="button"
              class="nav-menu-action"
              [attr.aria-label]="navListItem.name"
              (click)="
                navListItem.subMenu === undefined || navListItem.subMenu === null
                  ? onNavigate(navListItem)
                  : onShowSubMenu($event, navListItem)
              ">
              <div class="flex justify-between align-center">
                <div class="flex gap-10 align-center">
                  @if (navListItem.icon) {
                    <app-icon [name]="navListItem.icon" size="md" color="on-surface"></app-icon>
                  }
                  <p>{{ navListItem.name }}</p>
                </div>
                @if (navListItem.subMenu) {
                  <app-icon name="chevron_right" size="md" color="on-surface"></app-icon>
                }
              </div>
            </button>
          </mat-list-item>
        </div>
      }
      @if (subMenuMainItem === null && searchValue === '') {
        <mat-list-item class="nav-menu-item" role="listitem">
          <button type="button" class="nav-menu-action" aria-label="Logout" (click)="logout()">
            <div class="flex justify-between align-center">
              <div class="flex gap-10 align-center">
                <app-icon name="logout" size="md" color="on-surface"></app-icon>
                <p>Logout</p>
              </div>
            </div>
          </button>
        </mat-list-item>
      }
      @if (subMenuMainItem === null && searchValue === '') {
        <mat-list-item class="nav-menu-item" role="listitem">
          <div class="flex justify-between align-center">
            <div class="flex gap-10 align-center">
              <p>Dark Mode</p>
            </div>
            <mat-slide-toggle
              [ngModel]="vm.theme === 'dark'"
              (change)="setTheme($event)"
              class="theme-toggle"
              aria-label="Toggle dark mode"></mat-slide-toggle>
          </div>
        </mat-list-item>
      }
    </mat-list>
    <div class="legal">
      <a href="/privacy-policy" (click)="onLegalNavigate($event, '/privacy-policy')">Privacy Policy</a>
      <span> | </span>
      <a href="/terms-of-use" (click)="onLegalNavigate($event, '/terms-of-use')">Terms of Use</a>
    </div>
  </div>
</ng-container>
